import React, { useState } from 'react';
import axios from 'axios';
import './App.css'; 
import { Link } from "react-scroll";
import HeroSection from './components/HeroSection';
import Navbar from './components/Navbar';
import AboutMeSection from './components/AboutMeSection';
import TechnicalBackground from './components/TechnicalBackground';

function App() {
      const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // To show success or error message

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form behavior

    if (!email) {
      setStatus('Email is required');
      return;
    }

    const emailData = {
      email,
    };

    // Sending the email data to Laravel API using axios
    axios
      .post('https://manojmishra.in/laravel-react/api/send-email', emailData) // Replace with your actual URL
      .then((response) => {
        setStatus('Message sent successfully!'); // Show success message
        setEmail(''); // Reset email field
      })
      .catch((error) => {
        setStatus('Something went wrong'); // Show error message
        console.error(error); // Log the error
      });
  };

  return (
  <>
   <div data-bs-spy="scroll" data-bs-target=".navbar" data-bs-offset="80">
    <Navbar />
            <HeroSection />
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            {/* About Section */}
            <AboutMeSection />
           <TechnicalBackground />


        
        <section className="section" id="experience">
            <div className="container">                
                <div className="row justify-content-center mb-4">
                    <div className="col-12 col-md-10 col-lg-7 text-center">
                     
                        <h2 className="fs-2 fw-medium lh-1 text-dark my-3 position-relative z-i-2">Education & Experience</h2>
                       
                        <p className="text-gray-700 fs-18 fs-lg mb-4 mb-md-5 lh-lg">
                        Beyond technical proficiency, I possess a deep understanding of electronic systems and a passion for pushing the boundaries of what technology can achieve. From optimizing automotive systems and crafting precise instrumentation to developing advanced industrial applications, I thrive on tackling complex challenges. My expertise shines brightest in the realm of IoT, where I design, implement, and seamlessly integrate solutions with web and mobile applications, creating cohesive and user-friendly experiences. My command of microcontroller programming and sensor interfacing is exemplified by my successful development of applications for the full spectrum of Arduino boards and STM32 microcontrollers.

                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="main-timeline">
                                    <div className="timeline">
                                    <Link to="/desired-path" className="timeline-content">
                                       
                                            <div className="timeline-icon">
                                                <i className="ti ti-trophy"></i>
                                            </div>
                                            <div className="inner-content">
                                                <h3 className="title">Director - Quantalase Enterprises Pvt. Ltd.</h3>
                                                <p className="description">
                                                I’m expertised in firmware devleopment, embedded System & reverse engineering in the automotive domain.
                                                </p>
                                            </div>
                                            <div className="timeline-year"><span>2009-Present</span></div>
                                            </Link>
                                    </div>
                                    <div className="timeline">
                                    <Link to="/desired-path" className="timeline-content">
                                            <div className="timeline-icon">
                                                <i className="ti ti-users"></i>
                                            </div>
                                            <div className="inner-content">
                                                <h3 className="title">Technical Consultant - Nevaloss Technologies Pvt. Ltd.</h3>
                                                <p className="description">
                                                I have been working with this company and giving my services as a technical consultant. I have been guiding them for all new developments related to IOT, Embedded System, High Speed and Complex PCB Design and instrumentation.
                                                </p>
                                            </div>
                                            <div className="timeline-year"><span>2018-Present</span></div>
                                        </Link>
                                    </div>
                                    <div className="timeline">
                                    <Link to="/desired-path" className="timeline-content">
                                            <div className="timeline-icon">
                                                <i className="ti ti-school"></i>
                                            </div>
                                            <div className="inner-content">
                                                <h3 className="title">CPPM</h3>
                                                <p className="description">
                                                Certificate Programme in Project Management (CPPM) at the Indian Institute of Management Indore (IIM Indore)
                                                </p>
                                            </div>
                                            <div className="timeline-year"><span>2025</span></div>
                                        </Link>
                                    </div>
                                    <div className="timeline">
                                    <Link to="/desired-path" className="timeline-content">
                                            <div className="timeline-icon">
                                                <i className="ti ti-school"></i>
                                            </div>
                                            <div className="inner-content">
                                                <h3 className="title">BE Degree</h3>
                                                <p className="description">
                                                I have completed BE in Electronics and Communication from RGPV University.
                                                </p>
                                            </div>
                                            <div className="timeline-year"><span>2003-07</span></div>
                                        </Link>
                                    </div>
                                    <div className="timeline">
                                    <Link to="/desired-path" className="timeline-content">
                                            <div className="timeline-icon">
                                                <i className="ti ti-building"></i>
                                            </div>
                                            <div className="inner-content">
                                                <h3 className="title">High / Higher secondary school</h3>
                                                <p className="description">
                                                My high and higher education is completed from the state government board.                                                </p>
                                            </div>
                                            <div className="timeline-year"><span>2000-02</span></div>
                                        </Link>
                                    </div>
                                </div>
                            </div>                                                       
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
       
         
        <div className="position-relative"> 
            <div className="shape overflow-hidden text-light"> 
                <svg viewBox="0 0 2880 150" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M110 105L2160 0H2880V150H0V105H110Z" fill="currentColor"></path> </svg>
            </div>
        </div>
        
        <section className="section bg-light" id="contact">
            <div className="container">            
                <div className="row align-items-center">
                    <div className="col-lg-6">
                       
                        <h3 className="text-dark">I Am Available For Freelancer.</h3>
                        <p className="text-muted mb-0">Always ready to work on innovative projects to solve the problems and deliver effective outcomes.
                        </p>
                    </div> 
                    <div className="col-lg-6 ml-auto">
                        <div className="cta-search">
                            <form className="position-relative" onSubmit={handleSubmit}>
                                <input type="email" placeholder="Email Address" required="" value={email} onChange={(e) => setEmail(e.target.value)}/>
                               
                                <button type="submit" className="btn btn-dark">Send Massage</button>
                            </form>
                            {status && <p style={{ color: 'red' }}>{status}</p>}
                        </div>
                    </div> 
                </div> 
            </div>
        </section>
       
        <section className="section bg-light" id="contact">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                       
                                <div className="row">
                                    <div className="col-md-6">
                                    	 <div className="card bg-white" >
                            <div className="card-body">
                                      <div className="d-flex">
                                            <div className="bg-light d-flex justify-content-center align-items-center thumb-lg  rounded">
                                                <i className="ti ti-phone fs-22"></i>
                                            </div>
                                            <div className="align-self-center ms-3">
                                                <span className="d-block lh-1">+91 9754183845</span>
                                                <span className="text-muted fs-14 mt-n2">9:00am to 7:00pm</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    </div>

                                    <div className="col-md-6">
                                       <div className="card bg-white" >
                            <div className="card-body">
                                        <div className="d-flex">
                                            <div className="bg-light d-flex justify-content-center align-items-center thumb-lg  rounded">
                                                <i className="ti ti-mail fs-22"></i>
                                            </div>
                                            <div className="align-self-center ms-3">
                                                <span className="d-block lh-1">manoj@nevalosstechnologies.com</span>
                                                <span className="text-muted fs-14 mt-n2">Monday to Saturday</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       


        <div className="position-relative">
            <div className="shape overflow-hidden bg-footer">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>



        <div className="footer-alt">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center">
                         <p>Copyright @2026. Designed & Developed by <a href="https://www.nevalosstechnologies.com/" target="_blank" rel="noopener noreferrer" className="text-danger">Nevaloss Technologies Private Limited</a> . All Rights Reserved</p>
                       
                    </div>
                  
                </div>
               
            </div>
            
        </div>
      
         </div>
</>
  );
}

export default App;
